import { TMembershipLike } from '../types/TMembershipLike';

export const pickMemberships = (roster: readonly TMembershipLike[], membershipIds: readonly string[]) => {
  const byId = new Map(roster.map((membership) => [membership.id, membership]));

  return membershipIds.reduce<TMembershipLike[]>((picked, membershipId) => {
    const membership = byId.get(membershipId);

    return membership ? [...picked, membership] : picked;
  }, []);
};
